(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.blog-posts-carousel').forEach(function (section) {
      var sectionId = section.getAttribute('data-section-id');
      var scroller = document.getElementById('BPC-Slider-' + sectionId);

      if (!scroller) return;

      var prevBtn = section.querySelector('.slider-button--prev');
      var nextBtn = section.querySelector('.slider-button--next');
      var buttons = section.querySelector('.slider-buttons');

      function hasOverflow() {
        return scroller.scrollWidth > scroller.clientWidth + 1;
      }

      function getGap() {
        var styles = window.getComputedStyle(scroller);
        var gap = parseFloat(styles.columnGap) || parseFloat(styles.gap) || 0;

        return isNaN(gap) ? 0 : gap;
      }

      function firstSlideStep() {
        var first = scroller.querySelector('.slider__slide');

        if (!first) {
          return Math.max(200, Math.floor(scroller.clientWidth * 0.9));
        }

        return first.getBoundingClientRect().width + getGap();
      }

      function go(dir) {
        var step = firstSlideStep();

        scroller.scrollBy({
          left: dir * step,
          behavior: 'smooth',
        });
      }

      function updateButtonsState() {
        if (!buttons) return;

        buttons.style.display = hasOverflow() ? 'flex' : 'none';

        if (!prevBtn || !nextBtn) return;

        var maxScroll = scroller.scrollWidth - scroller.clientWidth - 1;
        var atStart = scroller.scrollLeft <= 1;
        var atEnd = scroller.scrollLeft >= maxScroll;

        prevBtn.toggleAttribute('disabled', atStart);
        nextBtn.toggleAttribute('disabled', atEnd);

        prevBtn.style.display = atStart ? 'none' : 'flex';
        nextBtn.style.display = atEnd ? 'none' : 'flex';
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          go(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          go(1);
        });
      }

      scroller.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateButtonsState);
      });

      window.addEventListener('resize', function () {
        setTimeout(updateButtonsState, 50);
      });

      setTimeout(updateButtonsState, 120);
      setTimeout(updateButtonsState, 500);
    });
  });
})();
